import { render } from "./PropertyManagement.vue?vue&type=template&id=52e85142"
import script from "./PropertyManagement.vue?vue&type=script&lang=js"
export * from "./PropertyManagement.vue?vue&type=script&lang=js"

import "../assets/css/property.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__